import Vue from "vue";
import router from "./router";
import store from "./store";
import { sync } from "vuex-router-sync";
import App from "./components/app-root";
import BootstrapVue from "bootstrap-vue";
import httpConfig from "./api/config";
import moment from "moment";
import Vuelidate from "vuelidate";

import DoughnutChart from "./components/charts/DoughnutChart.js";
Vue.component("doughnut-chart", DoughnutChart);

import BarChart from "./components/charts/BarChart.js";
Vue.component("bar-chart", BarChart);

import {
  FontAwesomeIcon,
  FontAwesomeLayers
} from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas, faBars } from "@fortawesome/free-solid-svg-icons";

library.add(fas, faBars);

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
require("toastr/toastr.scss");
import "./css/asu.css";
import "./css/site.css";

Vue.prototype.$http = httpConfig();

Vue.filter("formatDate", function(value) {
  if (value) {
    return moment(String(value)).format("MM/DD/YYYY");
  }
});

Vue.filter("formatDateTime", function(value) {
  if (value) {
    return moment(String(value)).format("MM/DD/YYYY h:mm A");
  }
});

Vue.filter("trueOrFalse", function(value) {
  if (value) {
    return "Yes";
  }
  return "No";
});

Vue.filter("number", function(value, precision) {
  return value.toFixed(precision);
});

Vue.filter("percentage", function(value, precision = 2) {
  if (value) {
    return (value * 100).toFixed(precision);
  }
  return value;
});

Vue.use(BootstrapVue);
Vue.use(Vuelidate);

// Leaflet
import "leaflet/dist/leaflet.css";

const L = require("leaflet");

// changes so that leaflet's images work after going through webpack
import marker from "leaflet/dist/images/marker-icon.png";
import marker2x from "leaflet/dist/images/marker-icon-2x.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: marker2x,
  iconUrl: marker,
  shadowUrl: markerShadow
});

sync(store, router);

const app = new Vue({
  store,
  router,
  ...App
});

Vue.config.productionTip = false;

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("font-awesome-layers", FontAwesomeLayers);

app.$mount("#app");
